import React, { Component } from 'react';
import { documentsRoutes } from '../../AppRoutes';
import { alfrescoTypes, attachmentStatuses, formFieldTypes, formModes, UserContext, documentStatuses } from '../../constants';
import i18next from "../../i18n";
import { getAttachmentsDictionary } from '../Dictionary';
import { buildFormSection, getFormSetting, getMainDocumentPdf, handleGetDocumentError, handlerCloseDocument, renderMainFile, updateServerStorage, documentActionHandlerCallback, rendercomments, renderconnections, rendersigners, rendereditingRights, handleSubmit } from '../document/DocumentHelpers';
import { History } from '../helpers/History';
import { hideModalDialog } from '../ModalDialog';
import PropTypes from 'prop-types';
import { getUrlParam } from '../helpers/HelperFunctions';
import * as DocumentSettings from '../document/DocumentSettings';
import { DocumentTitle } from '../document/DocumentTitle';
import { Tabs } from '../Tabs';
import { outgoingDocumentKinds } from './outgoingDocument';
export class Document extends Component {
    static contextType = UserContext;
    static propTypes = {
        baseDocument: PropTypes.object
    };
    constructor(props) {
        super(props);
        const documentsRouteSettings = documentsRoutes.find((item) => window.location.pathname.toLowerCase().startsWith("/" + item.baseUrl.toLowerCase()));
        this.state = {
            comments: [],
            formMode: documentsRouteSettings ? formModes.create : window.location.pathname.split("/")[2],
            loading: true,
            isCretor: false,
            isPerformer: true,
            submitted: false,
            form: [],
            activeTab: getUrlParam("tab") ? getUrlParam("tab") : DocumentSettings.documentTabs.information,
            creatorInfo: {},
            performerInfo: {},
            signers: [],
            externalSigners: [],
            additionalDocuments: [],
            additionalCounterparties: {},
            mainB64Pdf: "",
            mainDocuments: [],
            attachments: [],
            actions: [],
            attachmentsTypes: [],
            type: documentsRouteSettings?.alfrescoType ? documentsRouteSettings?.alfrescoType : "",
            currentStageSignatures: []
        };
        //this.state.submitted = this.state.formMode !== formModes.read;
        this.renderMainFile = renderMainFile.bind(this);
        this.actionHandlerCallback = documentActionHandlerCallback.bind(this);
        this.getMainDocumentPdf = getMainDocumentPdf.bind(this);
        this.buildFormSection = buildFormSection.bind(this);
        this.rendercomments = rendercomments.bind(this);
        this.rendereditingRights = rendereditingRights.bind(this);
        this.renderconnections = renderconnections.bind(this);
        this.rendersigners = rendersigners.bind(this);
        this.addUser = this.addUser.bind(this);
        this.addUserToSigners = this.addUserToSigners.bind(this);
    }
    componentDidMount() {
        this.getForm.bind(this)();
    }
    componentWillUnmount() {
        if (this.updateStorageIntervalId) {
            clearInterval(this.updateStorageIntervalId);
        }
    }
    render() {
        const { loading, formMode, prop_cm_title, activeTab, prop_sx_documentType, settings, type, prop_sx_state, prop_sx_states } = this.state;            
        if (loading) return ("");
        for (const [key, value] of Object.entries(require(`./${type.split(':')[1]}`))) if (typeof value === 'function') this[key] = value.bind(this);
        settings.tabs.find((item) => item.name === DocumentSettings.documentTabs.connections).hidden = prop_sx_state === settings.statuses.preparation;
        const activeTabs = settings.tabs.filter(item => item.documentTypes?.find((item) => item.toLowerCase() === type.toLowerCase()) || item.documentTypes?.length === 0);
        return (<div className="document">
            {(settings.tabs?.length > 0 ?
                <div className="content">
                    <DocumentTitle formMode={formMode} documentType={prop_sx_documentType} title={prop_cm_title} status={prop_sx_state} states={prop_sx_states} />
                    <form name="form" onSubmit={(e) => { e.preventDefault(); handleSubmit.bind(this); }}>
                        <Tabs name="tab" tabs={activeTabs} activeTab={activeTab.toString()} tabChangedCallback={(index) => this.setState({ activeTab: index })}>
                            {activeTabs.map((item) => this["render" + item.name]())}
                        </Tabs>
                    </form>
                </div> : "")}
        </div>);
    }
    addUser(user) {
        hideModalDialog('modalDialog');
        let { signers } = this.state;
        signers = this.addUserToSigners(user, signers);
        this.setState({ signers: signers });
    }
    addUserToSigners(user, signers) {
        let currentIndex = signers.findIndex(u => u.columns.Id === user.Id);
        if (currentIndex < 0) signers.push({ actions: [], columns: user });
        else signers[currentIndex].columns = user;
        return signers;
    }
    async getForm(id) {
        const { formMode } = this.state;
        let documentId = id ? id : window.location.pathname.split("/")[3];
        let newState = { user: this.context, signers: [] };
        let getMainDocumentTask;
        let getAttachmentsDictionaryTask;
        let initForm = async function (documentId) {
            let data = {};
            if (documentId) {
                data = await fetch(`/document/get/${documentId}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
                    .then(async response => {
                        if (!response.ok) return handleGetDocumentError.bind(this)(response.status);
                        let data = await response.json();
                        const properties = JSON.parse(data.properties);

                        if (formMode === formModes.edit && !data.isEditAllowed)
                            return handleGetDocumentError.bind(this)(406, `/document/read/${documentId}`);;

                        Object.keys(properties).forEach((key) => {
                            newState["prop_" + key.replaceAll(":", "_").replace("-", "_")] = properties[key];
                        });

                        Object.keys(data).forEach(function (key) {
                            newState[key] = data[key];
                        });
                        return data;
                    })
                if (!data) return;
            }
            const type = newState.type ?? this.state.type;
            const prop_sx_docKind = newState.prop_sx_docKind ?? this.state.prop_sx_docKind;
            if (documentId && type.toLowerCase() !== alfrescoTypes.counterpartyAccreditationCard.toLowerCase() && type.toLowerCase() !== alfrescoTypes.certificate.toLowerCase() && !(type === alfrescoTypes.outgoingDocument && prop_sx_docKind === outgoingDocumentKinds.reconciliationAct)) getMainDocumentTask = this.getMainDocumentPdf(newState);
            if (type.toLowerCase() === alfrescoTypes.counterpartyAccreditationCard.toLowerCase() || type.toLowerCase() === alfrescoTypes.simpleCounterpartyAccreditationCard.toLowerCase() || type.toLowerCase() === alfrescoTypes.certificate.toLowerCase()) getAttachmentsDictionaryTask = getAttachmentsDictionary(type);
            const formSettigs = await getFormSetting(type);
            const form = formSettigs?.form;
            if (!form) return;
            newState.form = form;
            newState.templateFolder = formSettigs.templateFolder;
            let storageTimeInterval = this.context.storageTimeInterval;
            if (storageTimeInterval && formMode === formModes.edit) {
                if (this.updateStorageIntervalId) clearInterval(this.updateStorageIntervalId);
                this.updateStorageIntervalId = setInterval(updateServerStorage.bind(this), storageTimeInterval * 60000);
            }
            if (formMode === formModes.create) {
                History.block((location) => {
                    if (documentsRoutes.find((item) => item.alfrescoType === type) && (location.pathname.toLowerCase() !== window.location.pathname.toLowerCase())) {
                        handlerCloseDocument.bind(this)(location.pathname);
                        return false;
                    }
                    return true;
                });
            }
            for (let i = 0; i < newState.form?.Fields?.length; ++i) {
                let { Name, Value, Type } = newState.form.Fields[i];
                newState.form.Fields[i].Label = { Label: i18next.t(`documentForm.${type.replace(":", "_")}.field.${Name}`) };
                if (Name) {
                    Value = newState[Name] !== undefined ? newState[Name] : Value;
                    if (Type === formFieldTypes.select) {
                        newState[Name] = newState.form?.Fields[i]?.Values?.Data?.length > 0 ? (Value ? Value : newState.form?.Fields[i]?.Values?.Data[0]?.Value) : "";
                        newState[`${Name}s`] = newState.form?.Fields[i]?.Values?.Data;
                    }
                    else newState[Name] = (Value || Type === formFieldTypes.bool) ? Value : "";
                }
            }
            return Object.assign({ type: type }, data);
        }
        const data = await initForm.bind(this)(documentId);
        if (!data) return;
        const type = data.type;
        if (!data && formMode !== formModes.create) return;
        if (type.toLowerCase() === alfrescoTypes.counterpartyAccreditationCard.toLowerCase() || type.toLowerCase() === alfrescoTypes.simpleCounterpartyAccreditationCard.toLowerCase() || type.toLowerCase() === alfrescoTypes.certificate.toLowerCase()) {
            const { companyTypeValue, registerCodeEDRPOU, companyKindValue, registerCodeIPN } = newState.user.companies[0];
            newState.prop_sxcfc_counterpartyType = companyTypeValue;
            newState.prop_sxcfc_codeEDRPOU = registerCodeEDRPOU;
            newState.prop_sxcfc_codeIPN = newState.prop_sxcfc_codeIPN ? newState.prop_sxcfc_codeIPN : registerCodeIPN;
            newState.prop_sxcfc_counterpartyKind = companyKindValue;
        }
        newState.attachments = [];
        if (documentId) {
            for (let i = 0; i < data?.attachments?.length; ++i) {
                let { nodeRef, properties, signatures } = data.attachments[i];
                newState.attachments.push({
                    id: nodeRef ? nodeRef : i + 1,
                    nodeRef: nodeRef,
                    created: properties?.created,
                    title: properties?.title,
                    state: (properties?.state === attachmentStatuses.Signed && id) ? attachmentStatuses.New : properties?.state,
                    documentDate: properties?.documentDate,
                    documentType: properties?.documentType,
                    mainDocumen: properties?.mainDocument,
                    documentNumber: properties?.documentNumber,
                    comment: properties?.comment,
                    signs: signatures?.signatures
                });
            }
            let additionalDocuments = [];
            for (let i = 0; i < data?.attachments?.length; ++i) {
                const { created, fileName } = data.attachments[i].properties;
                additionalDocuments.push({
                    creatorFullName: data.attachments[i].creatorInfo?.creatorFullName,
                    id: data.attachments[i].nodeRef,
                    nodeRef: data.attachments[i].nodeRef,
                    minType: data.attachments[i].minType,
                    created: created,
                    fileName: fileName
                });
            }
            Object.assign(newState, {
                isCretor: data.isCretor,
                isPerformer: data.isPerformer,
                isAdditionalSigningAllowed: data.isAdditionalSigningAllowed,
                additionalDocuments: additionalDocuments,
                externalSigners: data.externalSigners,
                additionalCounterparties: data.additionalCounterparties,
                signatures: data.signatures,
                associations: data.associations,
                dateLoaded: data.dateLoaded,
                isEditAllowed: data.isEditAllowed
            });
            let signatories = data?.signatories?.map(function (item) {
                for (var key in item) {
                    item[key.charAt(0).toUpperCase() + key.slice(1)] = item[key];
                    delete item[key];
                }
                return item;
            });
            for (let i = 0; i < signatories?.length; ++i) {
                newState.signers = this.addUserToSigners(signatories[i], newState.signers)
            };
        }
        if (getAttachmentsDictionaryTask) {
            newState.attachmentsTypes = await getAttachmentsDictionaryTask ?? [];
        }
        const { attachmentsTypes } = newState;
        if (type.toLowerCase() === alfrescoTypes.counterpartyAccreditationCard.toLowerCase() || type.toLowerCase() === alfrescoTypes.simpleCounterpartyAccreditationCard.toLowerCase() || type.toLowerCase() === alfrescoTypes.certificate.toLowerCase()) {
            for (let i = 0; i < attachmentsTypes?.length; ++i) {
                if (newState.attachments.findIndex(a => a.documentType === attachmentsTypes[i].value) < 0) {
                    newState.attachments.push({
                        id: (i + 1).toString(),
                        state: attachmentStatuses.NotAdded,
                        documentType: attachmentsTypes[i].value
                    });
                }
            }
        }
        const documentsRouteSettings = documentsRoutes.find((item) => item.alfrescoType === type);
        const childComponentSettings = JSON.parse(JSON.stringify(require(`./${type.split(':')[1]}`).settings));
        childComponentSettings.actions = childComponentSettings.actions.map(item => Object.assign({ modes: [formModes.read] }, item)).concat(DocumentSettings.actions);
        if (id) {
            Object.assign(newState, {
                comments: [], prop_sys_node_uuid: "", formMode: formModes.create, prop_sx_state: documentStatuses.preparation
            });
            History.push(`${documentsRouteSettings.baseUrl}`);
        }
        if (getMainDocumentTask) {
            newState.mainDocuments = await getMainDocumentTask;
        }
        Object.assign(newState, {
            loading: false,
            type: type,
            prop_sx_documentType: documentsRouteSettings.prop_sx_documentType,
            settings: Object.assign(DocumentSettings.documentSettings, childComponentSettings)
        });
        this.setState(newState);
        require('../document/DocumentHelpers').setLocalStorage.bind(this)();
    }
}